import axios from 'axios';
import envService from "@/services/env.service";

const BASE_URL = envService.getApiBaseUrl() + '/admin/audits';

export default {
    getAudits() {
        return axios.get(BASE_URL);
    },
}